import type { FunctionComponent } from "react";

import Card from "~/components/Card/Card";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";

type Props = { invoiceData: Invoice, onUpdateClick?: () => void };

const InvoiceDescriptionSection: FunctionComponent<Props> = ({ invoiceData, onUpdateClick }) => {
	return <Card title="Beschreibung"
				 headerButtonText="Bearbeiten"
				 onHeaderButtonClick={onUpdateClick}>
		{invoiceData.description || "Keine Beschreibung vorhanden."}
	</Card>;
};

export default InvoiceDescriptionSection;